import React from 'react';
import { Container, Row, Col, Button, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQrcode } from '@fortawesome/free-solid-svg-icons';
import { useAuth } from '../contexts/AuthContext';

const Home = () => {
  const { user } = useAuth();

  return (
    <div>
      {/* Hero Section */}
      <section className="bg-primary text-white py-5">
        <Container>
          <Row className="align-items-center">
            <Col lg={6}>
              <h1 className="display-4 fw-bold mb-4">
                Transforme seus PDFs em livros digitais interativos
              </h1>
              <p className="lead mb-4">
                Crie experiências de leitura únicas com nosso visualizador flipbook. 
                Faça upload, compartilhe e visualize seus documentos PDF com animações 
                realistas de folhear páginas.
              </p>
              <div className="d-flex gap-3">
                {user ? (
                  <Button as={Link} to="/dashboard" variant="light" size="lg">
                    Meus PDFs
                  </Button>
                ) : (
                  <Button as={Link} to="/register" variant="light" size="lg">
                    Começar Agora
                  </Button>
                )}
                <Button as={Link} to="/gallery" variant="outline-light" size="lg">
                  Ver Galeria
                </Button>
              </div>
            </Col>
            <Col lg={6}>
              <div className="text-center">
                <div className="bg-white rounded p-4 shadow">
                  <h3 className="text-primary mb-3">📖 Visualizador Flipbook</h3>
                  <p className="text-muted">
                    Experiência de leitura imersiva com animações suaves
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Features Section */}
      <section className="py-5">
        <Container>
          <Row className="text-center mb-5">
            <Col>
              <h2 className="display-5 fw-bold">Recursos Principais</h2>
              <p className="lead text-muted">
                Tudo que você precisa para uma experiência de leitura digital perfeita
              </p>
            </Col>
          </Row>
          
          <Row>
            <Col md={4} className="mb-4">
              <Card className="h-100 border-0 shadow-sm">
                <Card.Body className="text-center p-4">
                  <div className="display-4 mb-3"><FontAwesomeIcon icon={faQrcode} /></div>
                  <h4>Visualização Interativa</h4>
                  <p className="text-muted">
                    Folheie páginas com gestos naturais, zoom, rotação e visualização em tela cheia.
                  </p>
                </Card.Body>
              </Card>
            </Col>
            
            <Col md={4} className="mb-4">
              <Card className="h-100 border-0 shadow-sm">
                <Card.Body className="text-center p-4">
                  <div className="display-4 mb-3">🔗</div>
                  <h4>Links Compartilháveis</h4>
                  <p className="text-muted">
                    Compartilhe seus documentos com links únicos e controle de privacidade.
                  </p>
                </Card.Body>
              </Card>
            </Col>
            
            <Col md={4} className="mb-4">
              <Card className="h-100 border-0 shadow-sm">
                <Card.Body className="text-center p-4">
                  <div className="display-4 mb-3">⚡</div>
                  <h4>Upload Rápido</h4>
                  <p className="text-muted">
                    Faça upload de PDFs com drag & drop e processamento automático de thumbnails.
                  </p>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* CTA Section */}
      <section className="bg-light py-5">
        <Container>
          <Row className="text-center">
            <Col>
              <h2 className="display-5 fw-bold mb-4">
                Pronto para começar?
              </h2>
              <p className="lead text-muted mb-4">
                Crie sua conta gratuita e comece a transformar seus PDFs hoje mesmo.
              </p>
              {!user && (
                <Button as={Link} to="/register" variant="primary" size="lg">
                  Criar Conta Grátis
                </Button>
              )}
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default Home;
